import { useState } from "react";
import { FormattedMessage } from "react-intl";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import UserInformationColumn from "./UserInformationColumn";
import UrlsAndTagsColumn from "./UrlsAndTagsColumn";
import PrivacySettingsModal from "./PrivacyModal/PrivacySettingsModal";

const useStyles = makeStyles(theme => ({
  borderLeft: {
    borderLeft: "1px solid #cacaca",
    paddingLeft: "12px!important",
    [theme.breakpoints.down("sm")]: {
      borderLeft: 0,
      paddingLeft: "5px!important",
    },
  },
}));

const AboutSection = ({ accountSettings, setAccountSettings }) => {
  const classes = useStyles();
  
  const [settingName, setSettingName] = useState(false);
  const [privacyModal, setPrivacyModal] = useState(false);
  const [privacyName, setPrivacyName] = useState(false);

  const {
    skillTags = [],
    visibilitySettings,
    webLinks = [],
  } = accountSettings || {};

  const { firstname, lastname } = accountSettings;

  const handleOpenPrivacySetting = ({ name, visibility }) => {
    setSettingName(name);
    setPrivacyModal(true);
    setPrivacyName(visibility);
  };

  const handleChange = value => {
    if (privacyName === "skillTags" || privacyName === "visibilitySettings") {
      const tempValues = {
        ...accountSettings,
        visibilitySettings: {
          ...accountSettings.visibilitySettings,
          [settingName]: value,
        },
      };

      setAccountSettings(tempValues);
    }

    if (privacyName === "weblinks") {
      const tempValues = [...accountSettings.webLinks];
      const newWeblink = tempValues[settingName];
      newWeblink.visibility = value;
      tempValues[settingName] = newWeblink;
      setAccountSettings({ ...accountSettings, webLinks: tempValues });
    }
    setPrivacyModal(false);
  };

  const directMessageOptions = [
    {
      value: "PUBLIC",
      name: <FormattedMessage id="settings.directMessage.option.public.name" />,
      description: <FormattedMessage id="settings.directMessage.option.public.description" />,
    },
    {
      value: "PRIVATE",
      name: <FormattedMessage id="settings.directMessage.option.private.name" />,
      description:
        <FormattedMessage
          id="settings.directMessage.option.private.description"
          values={{ nameOfUser: `${firstname} ${lastname}` }}
        />,
    },
  ];

  const visibilityOptions = [
    {
      value: "PUBLIC",
      name: <FormattedMessage id="settings.public" />,
    },
    {
      value: "PRIVATE",
      name: <FormattedMessage id="settings.onlyMe" />,
    },
  ];

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}>
        <UserInformationColumn
          accountSettings={accountSettings}
          handleOpenPrivacySetting={handleOpenPrivacySetting}
          setAccountSettings={setAccountSettings}
          visibility="visibilitySettings"
        />
      </Grid>
      <Grid item xs={12} md={6} className={classes.borderLeft}>
        <UrlsAndTagsColumn
          accountSettings={accountSettings}
          handleOpenPrivacySetting={handleOpenPrivacySetting}
          setAccountSettings={setAccountSettings}
          skillTags={skillTags}
          visibility="weblinks"
          visibilitySettings={visibilitySettings}
          webLinks={webLinks}
        />
      </Grid>
      {privacyModal && (
        <PrivacySettingsModal
          onChange={handleChange}
          onClose={() => setPrivacyModal(false)}
          open={privacyModal}
          options={
            settingName === "directMessage"
              ? directMessageOptions
              : visibilityOptions
          }
          title={
            settingName === "directMessage"
              ? <FormattedMessage id="settings.directMessage.title" />
              : <FormattedMessage id="settings.selectAudience" />
          }
          value={
            privacyName === "weblinks"
              ? webLinks[settingName].visibility
              : visibilitySettings[settingName]
          }
        />
      )}
    </Grid>
  );
};

export default AboutSection;
